;(function () {
  const desktopQuery = window.matchMedia('(min-width: 1100px)')

  function initJHNYNavigation() {
    document.querySelectorAll('[data-jhny-shop-menu]').forEach((menu) => {
      if (menu.dataset.jhnyNavigationReady === 'true') return
      menu.dataset.jhnyNavigationReady = 'true'

      const panel = menu.querySelector('.jhny-shop-menu__panel')
      const summary = menu.querySelector('.jhny-primary-nav__summary')
      const tabs = Array.from(menu.querySelectorAll('[data-jhny-format-tab]'))
      const formatPanels = Array.from(menu.querySelectorAll('[data-jhny-format-panel]'))
      let closeTimer = null

      const setPanelTop = () => {
        if (!panel || !summary) return
        document.documentElement.style.setProperty(
          '--jhny-menu-top',
          Math.max(0, summary.getBoundingClientRect().bottom) + 'px'
        )
      }

      const selectFormat = (format, moveFocus) => {
        tabs.forEach((tab) => {
          const selected = tab.dataset.jhnyFormatTab === format
          tab.classList.toggle('is-active', selected)
          tab.setAttribute('aria-selected', selected ? 'true' : 'false')
          tab.tabIndex = selected ? 0 : -1
          if (selected && moveFocus) tab.focus()
        })

        formatPanels.forEach((formatPanel) => {
          formatPanel.hidden = formatPanel.dataset.jhnyFormatPanel !== format
        })
      }

      tabs.forEach((tab, index) => {
        tab.addEventListener('pointerdown', (event) => {
          event.preventDefault()
        })
        tab.addEventListener('mousedown', (event) => {
          event.preventDefault()
        })
        tab.addEventListener('click', (event) => {
          event.preventDefault()
          cancelClose()
          const scrollX = window.scrollX
          const scrollY = window.scrollY
          selectFormat(tab.dataset.jhnyFormatTab, false)
          const restoreScroll = () => window.scrollTo(scrollX, scrollY)
          window.requestAnimationFrame(restoreScroll)
          window.setTimeout(restoreScroll, 180)
        })
        tab.addEventListener('keydown', (event) => {
          let nextIndex = null
          if (event.key === 'ArrowDown' || event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length
          if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length
          if (event.key === 'Home') nextIndex = 0
          if (event.key === 'End') nextIndex = tabs.length - 1
          if (nextIndex === null) return
          event.preventDefault()
          selectFormat(tabs[nextIndex].dataset.jhnyFormatTab, true)
        })
      })

      const cancelClose = () => {
        if (closeTimer === null) return
        window.clearTimeout(closeTimer)
        closeTimer = null
      }

      const openMenu = () => {
        if (!desktopQuery.matches) return
        cancelClose()
        setPanelTop()
        menu.open = true
      }

      const closeMenu = () => {
        if (!desktopQuery.matches) return
        cancelClose()
        closeTimer = window.setTimeout(() => {
          menu.open = false
          closeTimer = null
        }, 180)
      }

      menu.addEventListener('mouseenter', openMenu)
      menu.addEventListener('mouseleave', closeMenu)
      panel?.addEventListener('mouseenter', openMenu)
      panel?.addEventListener('mouseleave', closeMenu)
      menu.addEventListener('toggle', () => {
        if (menu.open) setPanelTop()
      })

      window.addEventListener('resize', () => {
        if (menu.open) setPanelTop()
      }, { passive: true })

      window.addEventListener('scroll', () => {
        if (menu.open) setPanelTop()
      }, { passive: true })

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && menu.open) {
          menu.open = false
          menu.querySelector('summary')?.focus()
        }
      })

      document.addEventListener('pointerdown', (event) => {
        if (menu.open && !menu.contains(event.target)) menu.open = false
      })
    })
  }

  initJHNYNavigation()
  document.addEventListener('shopify:section:load', initJHNYNavigation)
})()

